import React from 'react'
import {Route} from 'react-router-dom'

import Reflux from 'reflux-react-16'

import LightspeedSettings from './LightspeedSettings.js'
import WooCommerceSettings from './WooCommerceSettings.js'
import ShopifySettings from './ShopifySettings.js'
import CCVShopSettings from './CCVShopSettings.js'
import BolcomSettings from './BolcomSettings.js'
import MijnwebwinkelSettings from './MijnwebwinkelSettings.js'
import ShoptraderSettings from './ShoptraderSettings.js'
import SnelStartSettings from './SnelStartSettings.js'
import ExactSettings from './ExactSettings.js'
import MagentoSettings from './MagentoSettings.js'
import ShopwareSettings from './ShopwareSettings.js'
import PrestaShopSettings from './PrestaShopSettings.js'

import {Button, Card, Popup, H3, H5, S1, P, Row} from '../../../../components/UI/index.js'
import LyraSettings from './LyraSettings.js'
import t from '../../../../helpers/Languages.js'
import {formSpacing} from '../../../../components/UI/forms/index.js'

class WebshopSettings extends Reflux.Component {
    onClickDownload(file) {
        const path = `/downloads/${file}`
        const name = file
        const a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = path
        a.download = name
        a.click()
        document.body.removeChild(a)
    }

    onClickNavigate(link) {
        const {history} = this.props

        const user = {...this.props.user}

        if (!user.settings.webshops[link]?.active) {
            user.settings.webshops[link].active = true
            this.props.onChange(user, true)
        }

        history.push(`/klant/instellingen/koppelingen/webshops/${link}`)
    }

    onClickOpenPage(link) {
        window.open(link, '_blank')
    }

    onClickOpenWebsite(link) {
        window.open(link, '_blank')
    }

    render() {
        const {reseller, user, onChange} = this.props

        const webshops = [
            {name: 'Afosto', image: 'afostoLogo.png'},
            {name: 'Bol.com', link: 'bolcom', manualLink: 'https://handleiding.veloyd.nl/docs/bol-com/', image: 'bolcomLogo.png'},
            {name: 'CCV Shop', link: 'ccvshop', manualLink: 'https://handleiding.veloyd.nl/docs/ccv-shop/', image: 'ccvshopLogo.png'},
            {name: 'Exact Online', link: 'exactOnline', image: 'exact.png'},
            {name: 'Factif', manualLink: 'https://handleiding.veloyd.nl/docs/factif/', image: 'factif.png'},
            {name: 'Goedgepickt', manualLink: 'https://handleiding.veloyd.nl/docs/goedgepickt/', image: 'goedgepickt.png'},
            {name: 'Lightspeed', link: 'lightspeed', manualLink: 'https://handleiding.veloyd.nl/docs/lightspeed/', image: 'lightspeedLogo.png'},
            {name: 'Lyra', link: 'lyra', manualLink: 'https://handleiding.veloyd.nl/docs/lyra/', image: 'lyraLogo.png'},
            {name: 'Magento', link: 'magento', manualLink: 'https://handleiding.veloyd.nl/docs/magento-2/', image: 'magentoLogo.png'},
            {name: 'Mijnwebwinkel', link: 'mijnwebwinkel', manualLink: 'https://handleiding.veloyd.nl/docs/mijnwebwinkel/', image: 'mijnwebwinkel.png'},
            {name: 'MyShop', image: 'myshopLogo.png'},
            {name: 'Odoo', manualLink: 'https://handleiding.veloyd.nl/docs/odoo/', image: 'odoo.png'},
            {name: 'OpenCart', download: 'veloyd.ocmod.zip', image: 'opencartLogo.png'},
            {name: 'Picqer', manualLink: 'https://handleiding.veloyd.nl/docs/picqer/', image: 'picqerLogo.png'},
            {name: 'PrestaShop', link: 'prestashop', manualLink: 'https://handleiding.veloyd.nl/docs/prestashop/', image: 'prestaShopLogo.png'},
            {name: 'Shopforce', informationLink: 'https://www.shopforce.nl/', image: 'shopforce.png'},
            {name: 'Shopify', link: 'shopify', manualLink: 'https://handleiding.veloyd.nl/docs/shopify/', image: 'shopifyLogo.png'},
            {name: 'Shoptrader', link: 'shoptrader', manualLink: 'https://handleiding.veloyd.nl/docs/shoptrader/', image: 'shoptrader.png'},
            {name: 'Shopware', link: 'shopware', manualLink: 'https://handleiding.veloyd.nl/docs/shopware-6/', image: 'shopware.png'},
            ...(reseller.snelstartWebshopEnabled ? [{name: 'SnelStart', link: 'snelstart', image: 'snelstart.svg', contactReseller: true}] : []),
            {name: 'StoreKeeper', informationLink: 'https://www.storekeeper.online/nl/', image: 'storekeeper.png'},
            {name: 'WooCommerce', link: 'woocommerce', manualLink: 'https://handleiding.veloyd.nl/docs/woocommerce/', image: 'wooCommerceLogo.png'},
            {name: 'Zupr', informationLink: 'https://www.zupr.io/nl/', image: 'zupr.png'}
        ]

        return (
            <Card shadow style={{width: 793, padding: 24}}>
                <Route
                    path='/klant/instellingen/koppelingen/webshops'
                    exact
                    render={() => {
                        return (
                            <div style={{width: 800}}>
                                <H3 style={{marginBottom: 36}}>{t('webshops')}</H3>

                                <H5 style={{marginBottom: 24}}>{t('enabled')}</H5>

                                <Row style={{flexWrap: 'wrap'}}>
                                    {webshops.map((webshop) => {
                                        if (!user.settings.webshops[webshop.link]?.active) {
                                            return
                                        }

                                        return (
                                            <Card style={{margin: 12, padding: 12, width: 350}} key={webshop.name}>

                                                <Row style={{alignItems: 'center', marginBottom: 24}}>
                                                    <img style={{marginRight: 24, objectFit: 'contain'}} src={`/images/${webshop.image}`} width={64} height={64} />

                                                    <S1>{webshop.name}</S1>
                                                </Row>

                                                <Row style={{justifyContent: 'space-between', columnGap: formSpacing.columnGap}}>

                                                    {webshop.manualLink &&
                                                        <Button variant='text' onClick={this.onClickOpenPage.bind(this, webshop.manualLink)}>{t('manual')}</Button>
                                                    }

                                                    {webshop.informationLink &&
                                                        <Button variant='text' onClick={this.onClickOpenWebsite.bind(this, webshop.informationLink)}>{t('information')}</Button>
                                                    }

                                                    {webshop.link &&
                                                        <Button variant='text' onClick={this.onClickNavigate.bind(this, webshop.link)}>{t('settings')}</Button>
                                                    }

                                                    {webshop.download &&
                                                        <Button variant='text' onClick={this.onClickDownload.bind(this, webshop.download)}>{t('download')}</Button>
                                                    }
                                                </Row>
                                            </Card>
                                        )
                                    })}
                                </Row>

                                <H5 style={{marginBottom: 24, marginTop: 36}}>{t('available')}</H5>

                                <Row style={{flexWrap: 'wrap', marginBottom: 24}}>
                                    {webshops.map((webshop) => {
                                        if (user.settings.webshops[webshop.link]?.active) {
                                            return
                                        }

                                        return (
                                            <Card style={{margin: 12, padding: 12, width: 350}} key={webshop.name}>

                                                <Row style={{alignItems: 'center', marginBottom: 24}}>
                                                    <img style={{marginRight: 24, objectFit: 'contain'}} src={`/images/${webshop.image}`} width={64} height={64} />

                                                    <S1>{webshop.name}</S1>
                                                </Row>

                                                {webshop.contactReseller &&
                                                    <P style={{marginBottom: 12}}>{t('webshopContactReseller', reseller.settings?.accountName || reseller.name)}</P>
                                                }

                                                <Row style={{justifyContent: 'space-between', columnGap: formSpacing.columnGap}}>

                                                    {webshop.manualLink &&
                                                        <Button variant='text' onClick={this.onClickOpenPage.bind(this, webshop.manualLink)}>{t('manual')}</Button>
                                                    }

                                                    {webshop.informationLink &&
                                                        <Button variant='text' onClick={this.onClickOpenWebsite.bind(this, webshop.informationLink)}>{t('information')}</Button>
                                                    }

                                                    <div style={{flex: 1}} />

                                                    {webshop.link &&
                                                        <Button onClick={this.onClickNavigate.bind(this, webshop.link)}>{t('activate')}</Button>
                                                    }

                                                    {webshop.download &&
                                                        <Button variant='text' onClick={this.onClickDownload.bind(this, webshop.download)}>{t('download')}</Button>
                                                    }
                                                </Row>
                                            </Card>
                                        )
                                    })}
                                </Row>

                                <Popup ref={(ref) => this.popup = ref} />
                            </div>
                        )
                    }}
                />

                <Route path='/klant/instellingen/koppelingen/webshops/bolcom' render={(props) => <BolcomSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/ccvshop' render={(props) => <CCVShopSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/exactOnline' render={(props) => <ExactSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/lightspeed' render={(props) => <LightspeedSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/lyra' render={(props) => <LyraSettings {...props} reseller={reseller} customer={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/mijnwebwinkel' render={(props) => <MijnwebwinkelSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/shopify' render={(props) => <ShopifySettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/shoptrader' render={(props) => <ShoptraderSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/snelstart' render={(props) => <SnelStartSettings {...props} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/woocommerce' render={(props) => <WooCommerceSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/magento' render={(props) => <MagentoSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/shopware' render={(props) => <ShopwareSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
                <Route path='/klant/instellingen/koppelingen/webshops/prestashop' render={(props) => <PrestaShopSettings {...props} reseller={reseller} user={user} onChange={onChange} />} />
            </Card>
        )
    }
}

export default WebshopSettings
